// redux/store.js

import cartReducer from "@/app/redux/cart-management/cart-management-slice";
import authReducer from "@/app/redux/auth-management/auth-management-slice";
import loaderReducer from "@/app/redux/loading-management/loading-management-slice";
import productReducer from "@/app/redux/product-management/product-management-slice";
import orderReducer from "@/app/redux/order-management/order-management-slice";
import modalReducer from "@/app/redux/latest-version-modal-management/latest-version-modal-management-clice";

import { configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web

// Persist configuration
const authPersistConfig = { key: "auth", storage };
const loaderPersistConfig = { key: "loader", storage };
const cartPersistConfig = { key: "cart", storage };
const productPersistConfig = { key: "product", storage };
const orderPersistConfig = { key: "order", storage };
const modalConfig = { key: "modal", storage };

// Create persist reducers
const persistedAuthReducer = persistReducer(authPersistConfig, authReducer);
const persistedLoaderReducer = persistReducer(loaderPersistConfig, loaderReducer);
const persistedCartReducer = persistReducer(cartPersistConfig, cartReducer);
const persistedProductReducer = persistReducer(productPersistConfig, productReducer);
const persistedOrderReducer = persistReducer(orderPersistConfig, orderReducer);
const persistedModalReducer = persistReducer(modalConfig, modalReducer);

export function makeStore() {
  const store = configureStore({
    reducer: {
      modal: persistedModalReducer,
      cart: persistedCartReducer,
      auth: persistedAuthReducer,
      loader: persistedLoaderReducer,
      product: persistedProductReducer,
      order: persistedOrderReducer,
    },
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: ["auth/setUserFormDetails", "persist/PERSIST", "persist/REHYDRATE"],
        },
      }),
    devTools: process.env.NODE_ENV !== "production",
  });

  return store;
}

export const store = makeStore();
export const persistor = persistStore(store);
